import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_LISTA_USUARIOS_MATRICULAS = "setListUsuariosMatriculas"
export const SET_LISTA_USUARIOS_PESQUISA = "setListUsuariosPesquisa"
export const SET_LISTA_MATRICULAS_USUARIO = "setListMatriculasUsuarios"
export const SET_MESSAGE_ALERT = 'setMensagem'
export const SET_COUNT_CLIENTE = 'setCountCliente'
export const SET_LISTA_PRODUTORES = 'setListaProdutores'
const actions = {
    async create_usuario(context, value) {
        let message = await ApiService.post('usuario/criar', value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_usuario(context, value) {
        let message = await ApiService.put('usuario/atualizar/'+value.id, value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_usuarios(context, params) {
        await ApiService.get('usuario', {params: params})
            .then(response => context.commit(SET_LISTA_USUARIOS_MATRICULAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_usuarios(context, texto, tipo) {
        await ApiService.get('usuario/', texto, '/', tipo)
            .then(response => context.commit(SET_LISTA_USUARIOS_PESQUISA, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    
    async listar_matriculas_usuario(context, id) {
        await ApiService.get('matricula_grade_curricular/usuario/' + id)
            .then(response =>
                context.commit(SET_LISTA_MATRICULAS_USUARIO, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    
    async troca_senha(context, value) {
        let message = await ApiService.put('usuario/trocar/senha/'+value.id, value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    
    async count(context) {
        await ApiService.get('usuariocount')
            .then(response => context.commit(SET_COUNT_CLIENTE, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async listar_produtores(context) {
        await ApiService.get('usuario/produtor/lista')
            .then(response => context.commit(SET_LISTA_PRODUTORES, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
};

const getters = {};

const mutations = {
    [SET_LISTA_USUARIOS_MATRICULAS](state, value) {
        state.lista_usuarios = value
    },
    [SET_LISTA_USUARIOS_PESQUISA](state, value) {
        state.lista_usuarios = value
    },
    [SET_LISTA_MATRICULAS_USUARIO](state, value) {
        state.lista_usuario = value
    },
    [SET_LISTA_PRODUTORES](state, value) {
        state.lista_produtores = value
    },

    
    [SET_MESSAGE_ALERT](state, value) {
      
        let customMessage;
        if (typeof value.message === "object") {
    
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.msg,
        };
      },
      [SET_COUNT_CLIENTE](state, value) {
        state.count_cliente = value
    },
      
};

const state = {
    lista_usuarios: [],
    lista_usuario: [],
    count_cliente:{},
    lista_produtores:[]
};

export default {
    namespaced:true,
    state,
    actions,
    mutations,
    getters
};